import * as THREE from "three";
import type { AssetPipeline } from "../core/assets";
import { addLandmarkKit } from "./landmarks";

type HeightFn = (x: number, z: number) => number;

export function addWorldRichness(group: THREE.Group, getHeight: HeightFn, assets?: AssetPipeline): void {
  addLandmarkKit(group, getHeight, assets);
}
